// extracted by mini-css-extract-plugin
export default {"spinner-space":"Inspector_spinner-space__ovOMP","expcard":"Inspector_expcard__dcqlE","logo-container":"Inspector_logo-container__UtDpq"};